export const END_DATE = new Date("2025-10-12");
